// Socket service for real-time updates (fallback implementation)
class SocketService {
  constructor() {
    this.connected = false;
    this.callbacks = {};
  }

  connect() {
    // Fallback implementation - no actual socket connection
    console.log('Socket service: Using fallback mode (no real-time updates)');
    this.connected = true;
    return Promise.resolve();
  }

  disconnect() {
    this.connected = false;
    this.callbacks = {};
  }

  emitBookingUpdate(data) {
    // Fallback - just log the update
    console.log('Booking update (fallback):', data);
  }

  onBookingUpdate(callback) {
    this.callbacks.bookingUpdate = callback;
  }

  onQueueUpdate(callback) {
    this.callbacks.queueUpdate = callback;
  }

  joinStudioRoom(studioCode) {
    console.log(`Joined studio room (fallback): ${studioCode}`);
  }

  leaveStudioRoom(studioCode) {
    console.log(`Left studio room (fallback): ${studioCode}`);
  }

  emitQueueUpdate(studioCode, queueData) {
    console.log('Queue update (fallback):', { studioCode, queueData });
  }

  emit(event, data) {
    console.log(`Socket emit (fallback): ${event}`, data);
  }

  on(event, callback) {
    this.callbacks[event] = callback;
  }
}

const socketService = new SocketService();
export default socketService;